import { lazy } from "react";
import { lazyRetry } from "../../utils/helpers/lazyRetry";

const LazyLogin = lazy(() =>
  lazyRetry(() => import("../../pages/dynamic/login/index"))
);

const LazyAddFlightShop = lazy(() =>
  lazyRetry(() => import("../../pages/dynamic/add-flight-shop"))
);

const LazyMyProfile = lazy(() =>
  lazyRetry(() => import("../../pages/dynamic/profile/index"))
);

// Code Rewamp Routes 

const LazyShopManager = lazy(() =>
  lazyRetry(() => import("../../pages/dynamic/view-flight-shop-rewamp/shopManager"))
);
const LazyDashboardManager = lazy(() =>
  lazyRetry(() => import("../../pages/dynamic/dashboard-manager/dashboardManager"))
);
const LazyViewDashboard = lazy(() =>
  lazyRetry(() => import("../../pages/dynamic/view-dashboard/viewDashboard"))
);

const LazyQuickAccess = lazy(() => 
  lazyRetry(() => import("../../pages/dynamic/quick-access/quickAccess"))
);

const LazyLegacyDashboard= lazy (() =>
lazyRetry(()=>import("../../pages/dynamic/legacy-dashboard/legacyDashboard")))

const LazyLegacyDetail= lazy (() =>
lazyRetry(()=>import("../../pages/dynamic/legacy-dashboard/legacyDetail")))

const LazyComponents = () => {
  return {
    LazyLogin,
    LazyAddFlightShop,
    LazyMyProfile,
    LazyShopManager,
    LazyDashboardManager,
    LazyViewDashboard,
    LazyQuickAccess,
    LazyLegacyDashboard,
    LazyLegacyDetail
  };
};

export default LazyComponents;

